export default __webpack_public_path__ + "static/kim-02a4ce8c61b52416de6d27887ddfb4a6.png";